import VueRouter from 'vue-router'
import Layout from './components/Layout'
import Dashboard from './components/Dashboard'
import Source from './components/Source'
import CronPage from './components/CronPage'
import Settings from './components/Settings'
import JobsPage from './components/JobsPage'
import ConfigPage from './components/ConfigPage'
import LoginPage from './components/LoginPage'
import AuthCallbackPage from './components/AuthCallbackPage'
import AdminsPage from './components/AdminsPage'
import DocsPage from './components/DocsPage'
import RoadmapPage from './components/RoadmapPage'
import BoardsPage from './components/BoardsPage'
import ApplicationsPage from './components/ApplicationsPage'
import VendorsPage from './components/VendorsPage'
import InquiriesPage from './components/InquiriesPage'
import MarketingPage from './components/MarketingPage'
import ContactPage from './components/ContactPage'
import MlsDirectoryPage from './components/MlsDirectoryPage'
import StatusPage from './components/StatusPage'
import AcquisitionPage from './components/AcquisitionPage'
import PrivacyPage from './components/PrivacyPage'
import TermsPage from './components/TermsPage'
import NotFoundPage from './components/NotFoundPage'
import { authState } from './lib/auth'
import { isBrowserAuthConfigured } from './lib/supabase'
import { PRODUCT_NAME, PRODUCT_TAGLINE } from './lib/brand'

const DEFAULT_TITLE = `${PRODUCT_NAME} — ${PRODUCT_TAGLINE.replace(/\.$/, '')}`

const routes = [
  { path: '/', component: MarketingPage, meta: { public: true, title: DEFAULT_TITLE } },
  { path: '/announcement', component: AcquisitionPage, meta: { public: true, title: `Announcement · ${PRODUCT_NAME}` } },
  { path: '/mls-directory', component: MlsDirectoryPage, meta: { public: true, title: `MLS directory · ${PRODUCT_NAME}` } },
  { path: '/status', component: StatusPage, meta: { public: true, title: `Status · ${PRODUCT_NAME}` } },
  { path: '/contact', component: ContactPage, meta: { public: true, title: `Contact sales · ${PRODUCT_NAME}` } },
  { path: '/privacy', component: PrivacyPage, meta: { public: true, title: `Privacy · ${PRODUCT_NAME}` } },
  { path: '/terms', component: TermsPage, meta: { public: true, title: `Terms · ${PRODUCT_NAME}` } },
  { path: '/login', component: LoginPage, meta: { public: true, title: `Sign in · ${PRODUCT_NAME}` } },
  { path: '/auth/callback', component: AuthCallbackPage, meta: { public: true, title: DEFAULT_TITLE } },
  { path: '', component: Layout, props: true, meta: { requiresAuth: true }, children: [
    { path: '/dashboard', component: Dashboard },
    { path: '/cron', component: CronPage },
    { path: '/config', component: ConfigPage },
    { path: '/boards', component: BoardsPage },
    { path: '/applications', component: ApplicationsPage },
    { path: '/inquiries', component: InquiriesPage },
    { path: '/vendors', component: VendorsPage },
    { path: '/settings', component: Settings },
    { path: '/docs', component: DocsPage },
    { path: '/docs/:slug', component: DocsPage },
    { path: '/roadmap', component: RoadmapPage },
    { path: '/admins', component: AdminsPage, meta: { requiresSuperAdmin: true } },
    { path: '/sources/:sourceName', component: Source, props: true, name: 'source' },
    { path: '/jobs', component: JobsPage },
  ]},
  { path: '*', component: NotFoundPage, meta: { public: true, title: `404 · ${PRODUCT_NAME}` } },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    if (to.hash) return { selector: to.hash }
    return { x: 0, y: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  if (!authState.ready) {
    await authState.init()
  }

  const isPublic = to.matched.some(r => r.meta && r.meta.public)

  if (!isBrowserAuthConfigured()) {
    return next()
  }

  if (isPublic) {
    if (authState.isAuthenticated && to.path === '/login') {
      return next('/dashboard')
    }
    return next()
  }

  if (!authState.isAuthenticated) {
    // Dashboard is the signed-in home — send straight to login (no redirect loop noise)
    if (to.path === '/dashboard') {
      return next('/login')
    }
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  if (to.matched.some(r => r.meta && r.meta.requiresSuperAdmin) && !authState.isSuperAdmin) {
    return next('/dashboard')
  }

  return next()
})

router.afterEach((to) => {
  const match = [...to.matched].reverse().find((r) => r.meta && r.meta.title)
  document.title = (match && match.meta.title) || DEFAULT_TITLE
})

export default router
